import axios from "../axiosConfig";

import { FETCH_NOVEDADES, GET_NOVEDADES } from "./types";
import { tokenConfig } from "./auth";

// GET ARTICULOS
export const getNovedades =
  (domicilio_envio = "") =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_NOVEDADES,
      payload: true,
    });
    axios
      .get(`/articulos/novedades/?domicilio_envio=${domicilio_envio}`, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: GET_NOVEDADES,
          payload: res.data,
        });
      })
      .catch((err) => console.log(err));
  };
